import { createContext } from 'react';

export interface MotorsCTAInterface {
    isMotorsCTATask1?: boolean;
    isMotorsCTATask2?: boolean;
    isMotorsCTATask3?: boolean;
    isMotorsCTATask3_B?: boolean;
    isMotorsCTATask3_C?: boolean;
}

export interface RequestAQuoteFormInterface {
    adSource?: string;
    openRequestAQuoteForm: (preferredContactType: 'call' | 'quote') => void;
}

export const RequestAQuoteFormContext = createContext<RequestAQuoteFormInterface>({
    adSource: '',
    openRequestAQuoteForm: () => {},
});

export const MotorsCTAContext = createContext<MotorsCTAInterface>({
    isMotorsCTATask1: false,
    isMotorsCTATask2: false,
    isMotorsCTATask3: false,
    isMotorsCTATask3_B: false,
    isMotorsCTATask3_C: false,
});
